import * as types from './mutation-types'

export default {
  setAuthenticated ({ commit }, payload) {
    commit(types.SET_AUTHENTICATED, payload)
  },
  setIsImpersonating ({ commit }, payload) {
    commit(types.SET_IS_IMPERSONATING, payload)
  },
  setRegistrationData ({ commit }, payload) {
    commit(types.SET_REGISTRATION_DATA, payload)
  },
  set2fAuthentication ({ commit }, payload) {
    commit(types.SET_2F_AUTHENTICATION, payload)
  }
}
